import { QuoteRequest } from "@vertical-insure/shared"
import { Controller } from "react-hook-form"

export const AdditionalQuestions = ({
  additionalQuestions
} : {
  quoteRequest: QuoteRequest;
  additionalQuestions: {[key: string]: React.ReactNode}
}) => {
  return (
    <div className="space-y-4">
      {Object.entries(additionalQuestions).map(([fieldName, question], index) => (
        <div key={index}>
          <Controller defaultValue={undefined} name={fieldName} render={({field}) => (
            <div>
              <div className="text-sm font-semibold">{question}</div>
              <div className="flex space-x-4 ml-2">
                <label className={`flex gap-2 cursor-pointer py-1 text-sm sm:items-center`}>
                  <input {...field} value="yes" type="radio" checked={field.value === true} onChange={() => field.onChange(true)}/> Yes
                </label>
                <label className={`flex gap-2 cursor-pointer py-1 text-sm sm:items-center`}>
                  <input {...field} value="no" type="radio" checked={field.value === false} onChange={() => field.onChange(false)}/> No
                </label>
              </div>
            </div>
          )}/>
        </div>
      ))}
    </div>
  )
}
